export default __webpack_public_path__ + "static/UnicornsOfLove-0c72456a839645860704c62a9fc414a2.png";